import {FC} from 'react'
import {Glass} from 'jbc-front/components/icons'
import styles from './KeywordSearchBox.scss'

interface KeywordSearchBoxProps {
  onChange: (value: string) => void
  keyword?: string
  placeholder?: string
}

export const KeywordSearchBox: FC<KeywordSearchBoxProps> = ({onChange, keyword, placeholder}) => {
  return (
    <div className={styles.textBoxWrap}>
      <input
        type="text"
        className={styles.textBox}
        value={keyword}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      <span className={styles.icon}>
        <Glass size={16} />
      </span>
    </div>
  )
}
